import React from "react";


const TPRMhistory = () => {
  document.title = "tprm-history";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>tprm-history</h1>
        
      </div>
    </React.Fragment>
  );
};

export default TPRMhistory;
